var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",staticStyle:{"position":"relative"}},[_c('transition',{attrs:{"name":"fade2"}},[(_vm.load || _vm.demo)?_c('div',{staticClass:"loadWrap"},[_c('div',{attrs:{"id":"main"}},[_c('span',{staticClass:"spinner"})])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }